module.exports = __webpack_public_path__ + "static/brands-315bff364f802cba3b4b736a270d78f1.png";